import { styled } from '@slal/ui';
import { Text } from '@slal/ui/typography';

export const StyledLi = styled.li`
    margin-bottom: ${({ theme }) => theme.space[6]};
    color: ${({ theme }) => theme.colors.blue__secondary__80};
`;

export const StyledLiText = styled(Text)`
    color: ${({ theme }) => theme.colors.primaryText};
`;

StyledLiText.defaultProps = {
    tag: 'span',
    markdown: true,
};

export const StyledUl = styled.ul`
    padding-inline-start: 1em;
    margin-top: 0;

    ::marker {
        color: ${({ theme }) => theme.colors.primaryText};
    }
`;
